module.exports = __webpack_public_path__ + "img/vsHandCream4.4ed9acca.jpg";